import { connect } from 'react-redux';
import Scratchpad from './Scratchpad';
import { fetchScratchpad } from '../../redux/modules/scratchpad';

const mapStateToProps = ({
  scratchpad: { data, title, viewInScratchpad }
}) => ({
  data,
  title,
  viewInScratchpad
});

const mapDispatchToProps = {
  fetchScratchpad
};

export default connect(mapStateToProps, mapDispatchToProps)(Scratchpad);
